<template>
    <h1
        class="titulo_section_component"
        :class="{ 'a-medida-selected': isCustom }"
    >
        <template v-if="!isDisponible">
            <a href="/">Disponible</a>
        </template>
        <template v-else>
            <span class="selected">Disponible</span>
        </template>
        <template v-if="isDisponiblePublico">
            <span class="title-divider">|</span>
            <template v-if="!isCustom">
                <a href="/a-medida" class="beta-tooltip a-medida-link">
                    A medida<br />
                    <span class="beta-medida">BETA</span>
                    <span class="beta-tooltip-text">
                        La seccion A medida se encuentra en fase beta lo cual no impide que puedas realizar tus pedidos a medida con total tranquilidad. Contactanos si tienes cualquier problema.
                    </span>
                </a>
            </template>
            <template v-else>
                <span class="beta-tooltip a-medida-link a-medida-link-selected">
                    A medida<br />
                    <span class="beta-medida">BETA</span>
                    <span class="beta-tooltip-text">
                        La seccion A medida se encuentra en fase beta lo cual no impide que puedas realizar tus pedidos a medida con total tranquilidad. Contactanos si tienes cualquier problema.
                    </span>
                </span>
            </template>
        </template>
    </h1>
</template>

<script>
const customUri = "/a-medida";
import { mapGetters } from "vuex";
export default {
    name: "SectionTitle",
    computed: {
        isCustom() {
            return this.pathName.startsWith(customUri);
        },
        isDisponible() {
            return !this.isCustom;
        },
        pathName() {
            return window.location.pathname;
        },
        ...mapGetters("custom", ["isDisponiblePublico"])
    }
};
</script>

<style scoped>
.titulo_section_component {
    font-size: 1.7em;
    font-weight: bold;
    text-transform: none;
}

.titulo_section_component {
    color: #808081;
}

.titulo_section_component.a-medida-selected {
    width: calc(100% - 50px);
}

.titulo_section_component a {
    color: #808081;
    white-space: nowrap;
}

.titulo_section_component span {
    white-space: nowrap;
}

.titulo_section_component a:hover {
    text-decoration: none;
    color: #1d68a7;
}

.titulo_section_component .selected {
    border-bottom: 4px solid #028a83;
    padding-bottom: 2px;
    color: #333333;
}


.a-medida-link {
    padding: 0.4em 0.7em 0.5em 0.7em;
    border: 2px solid #fec82f;
    display: inline-block;
    box-shadow: 5px 5px #fec82f;
}

.a-medida-link-selected {
    border-color: #028a83;
    color: #333333;
    box-shadow: 5px 5px #028a83;
}

.beta-medida {
    font-size: 0.4em;
    font-weight: lighter;
    position: absolute;
    line-height: 0.2em;
}

@media (min-width: 360px) {
    .titulo_section_component {
        font-size: 1.5em;
    }
}

@media (min-width: 380px) {
    .titulo_section_component {
        font-size: 1.6em;
    }
}

@media (min-width: 400px) {
    .titulo_section_component {
        font-size: 1.75em;
    }
}

@media (min-width: 420px) {
    .titulo_section_component {
        font-size: 1.85em;
    }
}

@media (min-width: 450px) {
    .titulo_section_component {
        font-size: 2em;
    }
}

@media (min-width: 992px) {
    .titulo_section_component {
        font-size: 1.9em;
    }

    .title-divider {
        padding-left: 1.2rem;
        padding-right: 1.2rem;
    }
}
</style>
